import LivedigitalSDKError from './LivedigitalSDKError';

class InvalidRequestError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE: string = 'Invalid request';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? InvalidRequestError.DEFAULT_MESSAGE, errorCode ?? 'invalid_request', meta);
  }
}

export default InvalidRequestError;
